import React from 'react';
import ReactDOM from 'react-dom';
import Index from './pages/index';
import './index.scss';

ReactDOM.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
  document.getElementById('root'),
);
